import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ConfigProvider } from 'antd';
import './i18n';
import App from './App';
import theme from './theme';
import './index.css';
import './styles/admin.css';

// Create a React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

// Static helpers (message.*, Modal.confirm, notification.*) render outside the
// React tree, so without this they would ignore the theme and fall back to
// Ant Design's default blue.
ConfigProvider.config({
  holderRender: (children) => <ConfigProvider theme={theme}>{children}</ConfigProvider>,
});

// Custom styles for React Query Devtools
const customDevToolsStyle = `
  .react-query-devtools-button {
    opacity: 0.6 !important;
    transform: scale(0.85) !important;
    transition: all 0.3s ease !important;
  }
  .react-query-devtools-button:hover {
    opacity: 1 !important;
    transform: scale(0.9) !important;
  }
  .react-query-devtools-button svg {
    filter: saturate(0.8) brightness(1.1) !important;
  }
`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <style>{customDevToolsStyle}</style>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={theme}>
          <App />
        </ConfigProvider>
        <ReactQueryDevtools 
          initialIsOpen={false}
          buttonPosition="bottom-left"
          toggleButtonProps={{
            style: {
              marginLeft: '8px',
              marginBottom: '8px'
            }
          }}
        />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
